export const TOGGLE_THEME = "TOGGLE_THEME";
export const DESTROY_SESSION = "DESTROY_SESSION";
export const AUTH_ME = "AUTH_ME";
export const IS_LOGIN = "IS_LOGIN";
export const PLAN_LIST = "PLAN_LIST";

export const CLIENT_AUTH_LOADING = "CLIENT_AUTH_LOADING";
export const CLIENT_AUTH_ERROR = "CLIENT_AUTH_ERROR";
export const VENDOR_AUTH_LOADING = "VENDOR_AUTH_LOADING";
export const VENDOR_AUTH_ERROR = "VENDOR_AUTH_ERROR";
export const VENDOR_SIGNUP_LOADING = "VENDOR_SIGNUP_LOADING";
export const VENDOR_SIGNUP_ERROR = "VENDOR_SIGNUP_ERROR";
export const VENDOR_FORGOT_PASSWORD_LOADING = "VENDOR_FORGOT_PASSWORD_LOADING";
export const VENDOR_FORGOT_PASSWORD_ERROR = "VENDOR_FORGOT_PASSWORD_ERROR";
export const VENDOR_RESET_PASSWORD_LOADING = "VENDOR_RESET_PASSWORD_LOADING";
export const VENDOR_RESET_PASSWORD_ERROR = "VENDOR_RESET_PASSWORD_ERROR";
export const ALERT_MESSAGE = "ALERT_MESSAGE";
export const ALERT_MESSAGE_TYPE = "ALERT_MESSAGE_TYPE";

export const SECTOR_LIST = "SECTOR_LIST";
export const SECTOR_LOADING = "SECTOR_LOADING";
export const SECTOR_ERROR = "SECTOR_ERROR";
export const LANGUAGES_LIST = "LANGUAGES_LIST";
export const PRODUCT_LIST = "PRODUCT_LIST";
export const PRODUCT_REQUEST = "PRODUCT_REQUEST";
export const PRODUCT_LOADING = "PRODUCT_LOADING";
export const PRODUCT_ERROR = "PRODUCT_ERROR";

export const NOTIFICATION_LIST = "NOTIFICATION_LIST";
export const NOTIFICATION_COUNT = "NOTIFICATION_COUNT";
export const NOTIFICATION_READ = "NOTIFICATION_READ";
export const NOTIFICATION_READ_ROLLBACK = "NOTIFICATION_READ_ROLLBACK";
export const NOTIFICATION_LOADING = "NOTIFICATION_LOADING";
export const NOTIFICATION_ERROR = "NOTIFICATION_ERROR";

export const INQUIRY_LIST = "INQUIRY_LIST";
export const INQUIRY_LOADING = "INQUIRY_LOADING";
export const INQUIRY_ERROR = "INQUIRY_ERROR";
export const INQUIRY_DETAIL = "INQUIRY_DETAIL";
export const INQUIRY_DETAIL_LOADING = "INQUIRY_DETAIL_LOADING";
export const INQUIRY_DETAIL_ERROR = "INQUIRY_DETAIL_ERROR";
export const INQUIRY_QUOTATION_LOADING = "INQUIRY_QUOTATION_LOADING";
export const INQUIRY_QUOTATION_ERROR = "INQUIRY_QUOTATION_ERROR";

export const ORDER_LIST = "ORDER_LIST";
export const ORDER_LOADING = "ORDER_LOADING";
export const ORDER_ERROR = "ORDER_ERROR";
export const ORDER_DETAIL = "ORDER_DETAIL";
export const ORDER_DETAIL_LOADING = "ORDER_DETAIL_LOADING";
export const ORDER_DETAIL_ERROR = "ORDER_DETAIL_ERROR";
export const ORDER_STATUS_UPDATE_LOADING = "ORDER_STATUS_UPDATE_LOADING";
export const ORDER_STATUS_UPDATE_ERROR = "ORDER_STATUS_UPDATE_ERROR";
export const ORDER_RESPONSE_LOADING = "ORDER_RESPONSE_LOADING";
export const ORDER_RESPONSE_ERROR = "ORDER_RESPONSE_ERROR";

export const CHAT_LIST = "CHAT_LIST";
export const CHAT_LOADING = "CHAT_LOADING";
export const CHAT_ERROR = "CHAT_ERROR";
export const CHAT_DETAIL = "CHAT_DETAIL";
export const CHAT_DETAIL_LOADING = "CHAT_DETAIL_LOADING";
export const CHAT_MESSAGES = "CHAT_MESSAGES";
export const CHAT_MESSAGES_LOADING = "CHAT_MESSAGES_LOADING";
export const CHAT_MARK_MESSAGES_READ = "CHAT_MARK_MESSAGES_READ";
export const CHAT_SEND_LOADING = "CHAT_SEND_LOADING";
export const CHAT_SOCKET_READY = "CHAT_SOCKET_READY";
export const CHAT_MESSAGE_RECEIVED = "CHAT_MESSAGE_RECEIVED";
export const CHAT_MESSAGE_SENT = "CHAT_MESSAGE_SENT";
export const CHAT_UNREAD_COUNT = "CHAT_UNREAD_COUNT";

export const RoutesPaths = {
  LOGIN: "/",
  SIGNUP: "/signup",
  FORGOTPASSWORD: "/forgot-password",
  VERIFYOTP: "/verify-otp",
  DASHBOARD: "/dashboard",
  INQUIRIES: "/inquiries",
  ORDER: "/order",
  MESSAGE: "/message",
  SETTING: "/setting",
  TRANSACTIONS: "/transactions",
  DOCUMENT: "/document",
  INQUIRIESDETAILS: "/inquiries/:id",
  ORDERDETAILS: "/order/:id",
  PRODUCT: "/product",
  ADDPRODUCT: "/add-product",
  VIEWPRODUCT: "/product/view/:id",
  EDITPRODUCT: "/product/edit/:id",
};

const apiUrl = process.env.REACT_APP_API_URL?.trim().replace(/\/+$/, "");
const imageUrl = process.env.REACT_APP_API_IMAGE_URL?.trim().replace(/\/+$/, "");

if (!apiUrl) {
  throw new Error(
    "REACT_APP_API_URL is missing. Add it to .env and restart the development server.",
  );
}

export const backendUrl = apiUrl + "/api";
export const backendImageUrl = imageUrl;
export const VENDOR_PRODUCTS_LIST = "VENDOR_PRODUCTS_LIST";
export const VENDOR_PRODUCTS_LOADING = "VENDOR_PRODUCTS_LOADING";
export const VENDOR_PRODUCTS_ERROR = "VENDOR_PRODUCTS_ERROR";
export const VENDOR_PRODUCT_DETAIL = "VENDOR_PRODUCT_DETAIL";
export const VENDOR_PRODUCT_DETAIL_LOADING = "VENDOR_PRODUCT_DETAIL_LOADING";
export const VENDOR_PRODUCT_DETAIL_ERROR = "VENDOR_PRODUCT_DETAIL_ERROR";
export const VENDOR_PRODUCT_MUTATION_LOADING = "VENDOR_PRODUCT_MUTATION_LOADING";
export const VENDOR_PRODUCT_MUTATION_ERROR = "VENDOR_PRODUCT_MUTATION_ERROR";
export const VENDOR_PRODUCT_SECTORS = "VENDOR_PRODUCT_SECTORS";
export const VENDOR_PRODUCT_SECTORS_LOADING = "VENDOR_PRODUCT_SECTORS_LOADING";
export const VENDOR_PRODUCT_SECTORS_ERROR = "VENDOR_PRODUCT_SECTORS_ERROR";
export const VENDOR_PRODUCT_SECTOR_ITEMS = "VENDOR_PRODUCT_SECTOR_ITEMS";
export const VENDOR_PRODUCT_SECTOR_LOADING = "VENDOR_PRODUCT_SECTOR_LOADING";
export const VENDOR_PRODUCT_SECTOR_ERROR = "VENDOR_PRODUCT_SECTOR_ERROR";

export const VENDOR_DASHBOARD_DATA = "VENDOR_DASHBOARD_DATA";
export const VENDOR_DASHBOARD_LOADING = "VENDOR_DASHBOARD_LOADING";
export const VENDOR_DASHBOARD_ERROR = "VENDOR_DASHBOARD_ERROR";
